/**
 * @generated SignedSource<<2d0b171a8b3793f4236d04fcd585bf1d>>
 * @relayHash 220c1dc9971af7620525069e05c4802e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 557e099621709e324ddfa12255e9381a2dda552618cc3fb198af91465d7f8192

import type { ConcreteRequest } from 'relay-runtime';
export type WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation$variables = {
  id: string;
  includeChildren?: boolean | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation$data = {
  readonly watchContent: {
    readonly content: {
      readonly currentUserIsWatchingChildren: boolean | null | undefined;
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation = {
  response: WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation$data;
  variables: WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeChildren"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "id"
          },
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "includeChildren",
            "variableName": "includeChildren"
          }
        ],
        "kind": "ObjectValue",
        "name": "watchContentInput"
      }
    ],
    "concreteType": "WatchContentPayload",
    "kind": "LinkedField",
    "name": "watchContent",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "currentUserIsWatchingChildren"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "220c1dc9971af7620525069e05c4802e",
    "id": "557e099621709e324ddfa12255e9381a2dda552618cc3fb198af91465d7f8192",
    "metadata": {},
    "name": "WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation",
    "operationKind": "mutation",
    "text": "mutation WatchSettingsCheckboxItemsWatchDialogWatchChildrenMutation($id:ID!,$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id,currentUser:true,includeChildren:$includeChildren}){content{id,currentUserIsWatchingChildren}}}"
  }
};
})();

(node as any).hash = "e5b69a223926d9564180a06fcb387aaf";

export default node;
